module.exports = __webpack_public_path__ + "static/bcf-4b0c27c6f1ae619024f5bbc29881f54e.png";